import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from 'components/icon';
import { Slot } from 'react-page-layout';


export default function Alert({ meta, content }) {
    const { icon, title, description, type } = meta;
    return (
        <div className="modal--inner">
            <div className="modal--scroller">
                <div className="modal--content-wrapper">
                    <div className="modal--grid grid grid__condensed">
                        <div className="modal--container grid--container">
                            <div className={classnames('modal--content', {
                                [`modal--content__${ type }`]: type,
                            })}>
                                <div className="grid--row modal--title-wrapper">
                                    {icon && <Icon className="modal--icon" {...icon} />}
                                    <h2 className="modal--title">{title}</h2>
                                </div>
                                <div className="grid--row">
                                    <div className="grid--col">
                                        <p className="modal--paragraph">{ description }</p>
                                    </div>
                                </div>
                                <Slot name="content">
                                    {content}
                                </Slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Alert.propTypes = {
    meta: PropTypes.object.isRequired,
    content: PropTypes.any,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/modal/alert/index.js